// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subject_addition[data-v-ace3ba5a] {\n  vertical-align: sub;\n  font-weight: 400;\n  font-size: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
